export class Survey {
  static isEditable(survey = null) {
    return (
      survey !== null &&
      survey.rating === null &&
      survey.response_time_sat === null &&
      survey.work_quality_sat === null &&
      survey.recommend_spackle === null
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/survey.js